module.exports = __webpack_public_path__ + "img/reply.38b3c1f7.svg";